// paywall
export const ABO_BANNER_DESKTOP = "AboBannerDesktop";
export const ABO_BANNER_MOBILE = "AboBannerMobile";
export const PASSWORD_FORGOTTEN = "PasswordForgotten";
//kiosque
export const PAYWALL_REDIRECTION = "paywallRedirectionUrl";
export const LOGOUT_REDIRECTION = "logoutlRedirectionUrl";
export const TOPNAV_BUTTON = "button_topnav";
//settings
export const HELP = "Help";
export const DISCLAIMER = "Disclaimer";
export const DATAPOLICY = "DataPolicy";
export const PRIVACYPOLICY = "PrivacyPolicy";
//contact
export const CONTACT_CLIENT = "ContactClient";
export const CONTACT_TWIPE = "ContactTwipe";

export const COOKIE_MORE_INFO = "CookieMoreInfo";

export const IFRAME_KIOSQUE_MOBILE = "IframeKiosqueMobile";
export const IFRAME_KIOSQUE_TOP = "IframeKiosqueTop";
export const IFRAME_KIOSQUE_BOTTOM = "IframeKiosqueBottom";
export const IFRAME_KIOSQUE_ARCHIVE = "IframeKiosqueArchive";
export const IFRAME_KIOSQUE_ARCHIVE_BOTTOM = "IframeKiosqueArchiveBottom";



// WEBPACK FOOTER //
// ./src/common/utilities/redirectorKeys.js